var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tracked } from "@glimmer/tracking";
import RetrieveAndSaveDocuments from "cnam/components/cnam-services-access-form/process/loading/retrieve-and-save-documents";
import ProcessSuccessSaveOperations from "cnam/components/cnam-services-access-form/process/success/save-operations/index";
import DmpDocumentMetadata from "cnam/models/dmp-document-metadata";
import { InsStatus } from "cnam/types/types";
import { CnamApiDmpDocumentFailedToSave } from "cnam/utils/cnam-api-errors";
import createReimbursementFromXML from "cnam/utils/dmp-parsing";
import File from "core/models/file";
import { b64DecodeUnicode } from "core/utils/base64-decode-unicode";
import { sortBy } from "core/utils/sort";
import ControlTower from "wise-control-tower";
import { State } from "./abstract/cnam-context";
import DmpContext from "./abstract/dmp-context";
let DmpRetrievalContext = (_class = class DmpRetrievalContext extends DmpContext {
  constructor(cnamAdapterName, patient, authenticationContext, dmpAdapter, insiAdapter, store, fetcher, requestManager, onSuccessfulHrRetrieval) {
    super(cnamAdapterName, patient, authenticationContext, dmpAdapter, insiAdapter, store, requestManager, () => {
      this.store.createRecord("reimbursements-retrieved-journal-event", {
        patient,
        occurredAt: new Date(),
        success: false,
        cnamProcessStartedJournalEvent: this.cnamProcessStartedJournalEvent
      });
    });
    _defineProperty(this, "fetcher", void 0);
    _initializerDefineProperty(this, "documentsMetadataToRetrieve", _descriptor, this);
    _initializerDefineProperty(this, "documentsRetrievedJournalEventsToUpdate", _descriptor2, this);
    _initializerDefineProperty(this, "rembDocumentsMetadataToRetrieve", _descriptor3, this);
    _initializerDefineProperty(this, "hrRetrieved", _descriptor4, this);
    _initializerDefineProperty(this, "hrProcessEnded", _descriptor5, this);
    _initializerDefineProperty(this, "nonHrProcessEnded", _descriptor6, this);
    _initializerDefineProperty(this, "nonHrRetrieved", _descriptor7, this);
    _initializerDefineProperty(this, "nonHrUpdated", _descriptor8, this);
    _initializerDefineProperty(this, "documentsMetadataSaved", _descriptor9, this);
    _initializerDefineProperty(this, "documentRetrievingIndex", _descriptor10, this);
    _initializerDefineProperty(this, "totalDocumentsToRetrieve", _descriptor11, this);
    _initializerDefineProperty(this, "documentUpdatingIndex", _descriptor12, this);
    _initializerDefineProperty(this, "totalDocumentsToUpdate", _descriptor13, this);
    _initializerDefineProperty(this, "nonHrDocumentsOnError", _descriptor14, this);
    _initializerDefineProperty(this, "nonHrDocumentsUpdatesOnError", _descriptor15, this);
    _defineProperty(this, "successComponent", ProcessSuccessSaveOperations);
    this.fetcher = fetcher;
    this.states = [...this.states, new State("find-documents", () => {
      return Promise.resolve(this.documentsMetadataToRetrieve.length === 0 && this.documentsRetrievedJournalEventsToUpdate.length === 0 && this.patient.insStatus == InsStatus.Qualified);
    }, async () => {
      const documents = await this.findDocuments(this.patient, this.store);
      const jes = (await fetcher.query("dmp-document-retrieved-journal-event", {
        filter: {
          patient_id: patient.id
        }
      })).slice();
      this.rembDocumentsMetadataToRetrieve = await this.getRembDocumentsMetadataToRetrieve(documents, jes);
      this.documentsMetadataToRetrieve = await this.getDocumentsMetadataToRetrieve(documents, jes);
      this.documentsRetrievedJournalEventsToUpdate = await this.getDocumentsRetrievedJournalEventsToUpdate(documents, jes);
    }), new State("save-documents-metadata", () => {
      return Promise.resolve(!this.documentsMetadataSaved);
    }, async () => {
      await this.store.createRecord("dmp-documents-metadata-retrieved-journal-event", {
        occurredAt: new Date(),
        patient: this.patient,
        documentsMetadata: this.documentsMetadataToRetrieve,
        cnamProcessStartedJournalEvent: this.cnamProcessStartedJournalEvent
      }).save();
      this.documentsMetadataSaved = true;
    }), new State("retrieve-and-save-latest-reimbursements-document", () => {
      return Promise.resolve(this.rembDocumentsMetadataToRetrieve.length > 0 && !this.hrProcessEnded && this.patient.insStatus == InsStatus.Qualified);
    }, async () => {
      await this.retrieveAndSaveLastReimbursementDocument(this.rembDocumentsMetadataToRetrieve, this.patient, this.dmpAdapter, this.secretConnection, this.store, () => {
        this.hrRetrieved = true;
        return onSuccessfulHrRetrieval;
      });
      this.hrProcessEnded = true;
    }), new State("retrieve-and-save-documents", () => {
      return Promise.resolve((this.documentsMetadataToRetrieve.length > 0 || this.documentsRetrievedJournalEventsToUpdate.length > 0) && this.hrProcessEnded && !this.nonHrProcessEnded && this.patient.insStatus == InsStatus.Qualified);
    }, async () => {
      await this.retrieveAndSaveNonReimbursementDocuments(this.documentsMetadataToRetrieve, this.patient, this.dmpAdapter, this.secretConnection, this.store, () => {
        this.nonHrRetrieved = true;
      });
      await this.retrieveAndUpdateNonReimbursementDocuments(this.documentsRetrievedJournalEventsToUpdate, this.patient, this.dmpAdapter, this.secretConnection, () => {
        this.nonHrUpdated = true;
      });
      this.nonHrProcessEnded = true;
    }, undefined, RetrieveAndSaveDocuments), new State("save-operations", () => {
      return Promise.resolve(this.hrProcessEnded && this.nonHrProcessEnded && this.patient.insStatus == InsStatus.Qualified);
    }, async () => {
      await this.store.createRecord("cnam-process-ended-journal-event", {
        timedTransactions: this.timedTransactions,
        occurredAt: new Date(),
        patient: this.patient,
        cnamProcessStartedJournalEvent: this.cnamProcessStartedJournalEvent
      }).save();
      this.successKey = "dmp-retrieval";
    })];
  }
  reset() {
    super.reset();
    this.successKey = undefined;
    this.documentsMetadataToRetrieve = [];
    this.documentsRetrievedJournalEventsToUpdate = [];
    this.hrRetrieved = false;
    this.hrProcessEnded = false;
    this.nonHrProcessEnded = false;
    this.nonHrRetrieved = false;
    this.nonHrUpdated = false;
    this.nonHrDocumentsOnError = [];
    this.nonHrDocumentsUpdatesOnError = [];
  }

  // Those are documents that can been retrieved but the cdaHeaders
  // or the classCode or type are undefined
  async getDocumentsRetrievedJournalEventsToUpdate(documents, dmpDocumentRetrievedJournalEvents) {
    const documentsUniqueIdsInMetadata = documents.map(document => document.uniqueId);
    const isDmpDocumentRetrievedJournalEventMissingAnAttribute = dmpDocumentRetrievedJournalEvent => {
      return !dmpDocumentRetrievedJournalEvent.cdaHeaders || !dmpDocumentRetrievedJournalEvent.classCode || !dmpDocumentRetrievedJournalEvent.docType;
    };
    return dmpDocumentRetrievedJournalEvents.slice().filter(dmpDocumentRetrievedJournalEvent => isDmpDocumentRetrievedJournalEventMissingAnAttribute(dmpDocumentRetrievedJournalEvent) && documentsUniqueIdsInMetadata.includes(dmpDocumentRetrievedJournalEvent.uniqueId) && dmpDocumentRetrievedJournalEvent.docType !== "87273-9" && dmpDocumentRetrievedJournalEvent.docType !== "REMB" && dmpDocumentRetrievedJournalEvent.classCode !== "60").map(dmpDocumentRetrievedJournalEvent => {
      const documentMetadata = documents.find(document => document.uniqueId === dmpDocumentRetrievedJournalEvent.uniqueId);
      return {
        documentMetadata,
        dmpDocumentRetrievedJournalEvent
      };
    });
  }
  async getRembDocumentsMetadataToRetrieve(documents, dmpDocumentRetrievedJournalEvents) {
    return documents.filter(document => document.type === "REMB" && document.classCode === "60" && !dmpDocumentRetrievedJournalEvents.find(event => event.uniqueId === document.uniqueId));
  }
  async getDocumentsMetadataToRetrieve(documents, dmpDocumentRetrievedJournalEvents) {
    const alreadyRetrievedDocumentsIds = dmpDocumentRetrievedJournalEvents.slice().map(dmpDocumentRetrievedJournalEvent => dmpDocumentRetrievedJournalEvent.uniqueId);
    const documentsToReturn = alreadyRetrievedDocumentsIds.length > 0 ? documents.filter(document => !alreadyRetrievedDocumentsIds.includes(document.uniqueId) && document.type !== "87273-9" && document.type !== "REMB" && document.type !== "60") : documents;
    return documentsToReturn.map(document => new DmpDocumentMetadata(document));
  }
  async retrieveAndUpdateNonReimbursementDocuments(documentsRetrievedJournalEventsToUpdate, patient, dmpAdapter, secretConnection, onSuccess) {
    if (documentsRetrievedJournalEventsToUpdate.length > 0) {
      this.totalDocumentsToUpdate = documentsRetrievedJournalEventsToUpdate.length;
      const uniqueIds = [];
      for (const [index, documentRetrievedJournalEventToUpdate] of documentsRetrievedJournalEventsToUpdate.entries()) {
        this.documentUpdatingIndex = index;
        // In order to not stop the process, we
        // catch the error
        try {
          const documentContent = await dmpAdapter.td32RetrieveContent(patient.ins, documentRetrievedJournalEventToUpdate.documentMetadata, secretConnection);
          if (documentContent.cdaHeaders) {
            documentRetrievedJournalEventToUpdate.dmpDocumentRetrievedJournalEvent.cdaHeaders = documentContent.cdaHeaders;
          }
          documentRetrievedJournalEventToUpdate.dmpDocumentRetrievedJournalEvent.classCode ??= documentRetrievedJournalEventToUpdate.documentMetadata.classCode;
          documentRetrievedJournalEventToUpdate.dmpDocumentRetrievedJournalEvent.docType ??= documentRetrievedJournalEventToUpdate.documentMetadata.type;
          await documentRetrievedJournalEventToUpdate.dmpDocumentRetrievedJournalEvent.save();
          uniqueIds.push(documentRetrievedJournalEventToUpdate.documentMetadata.uniqueId);
        } catch (error) {
          this.nonHrDocumentsUpdatesOnError.push(documentRetrievedJournalEventToUpdate.documentMetadata);
          console.error("Details", error.error);
          ControlTower.captureException(error);
        }
      }
      if (uniqueIds.length > 0) {
        onSuccess();
      }
    }
  }
  async retrieveAndSaveNonReimbursementDocuments(nonReimbursementsDocumentsMetadata, patient, dmpAdapter, secretConnection, store, onSuccess) {
    if (nonReimbursementsDocumentsMetadata.length > 0) {
      this.totalDocumentsToRetrieve = nonReimbursementsDocumentsMetadata.length;
      const uniqueIds = [];
      for (const [index, documentMetadata] of nonReimbursementsDocumentsMetadata.entries()) {
        this.documentRetrievingIndex = index;

        // In order to not stop the process, we
        // catch the error
        try {
          const documentContent = await dmpAdapter.td32RetrieveContent(patient.ins, documentMetadata, secretConnection);
          const fileAttachment = store.createRecord("file-attachment", {
            mimeType: documentMetadata.mimeType,
            index: 0
          });
          const fileContent = store.createRecord("file-content", {
            data: documentContent.body,
            fileAttachment
          });
          const file = new File(fileAttachment, fileContent);
          const journalEventPayload = {
            type: "dmp-document-retrieved-journal-events",
            relationships: {
              patient: {
                data: {
                  id: patient.id,
                  type: "patients"
                }
              },
              "cnam-process-started-journal-event": {
                data: {
                  id: this.cnamProcessStartedJournalEvent.id,
                  type: "cnam-process-started-journal-events"
                }
              }
            },
            attributes: {
              occurredAt: documentMetadata.creationTime,
              title: documentMetadata.title,
              classCode: documentMetadata.classCode,
              docType: documentMetadata.type,
              mimeType: documentMetadata.mimeType,
              uniqueId: documentMetadata.uniqueId,
              cdaHeaders: documentContent.cdaHeaders
            }
          };
          const body = JSON.stringify({
            data: {
              "journal-event": {
                data: journalEventPayload
              },
              "file-attachments": [file.fileAttachment.serialize()],
              "file-contents": [file.fileContent.serialize()]
            }
          });
          const {
            response,
            content
          } = await this.requestManager.request({
            url: "/api/v1/journal_event_with_attachment",
            method: "POST",
            body: body
          });
          if (!response.ok) {
            throw new CnamApiDmpDocumentFailedToSave(`Failed to save document with uniqueId ${documentMetadata.uniqueId}`);
          } else {
            // Fetch saved record
            await this.store.findRecord(content.data.type.slice(0, -1), content.data.id, {
              include: "file-attachments"
            });
          }
          uniqueIds.push(documentMetadata.uniqueId);
        } catch (error) {
          this.nonHrDocumentsOnError.push(documentMetadata);
          console.error("Details", error.error);
          ControlTower.captureException(error);
        }
      }
      if (uniqueIds.length > 0) {
        onSuccess();
      }
    }
  }
  async retrieveAndSaveLastReimbursementDocument(reimbursementsDocumentsMetadata, patient, dmpAdapter, secretConnection, store, onSuccessfulHrRetrieval) {
    if (reimbursementsDocumentsMetadata.length > 0) {
      const reimbursementsDocumentContent = await dmpAdapter.td32RetrieveContent(patient.ins, reimbursementsDocumentsMetadata.sort(sortBy("creationTime")).at(-1), secretConnection);
      const xml = b64DecodeUnicode(reimbursementsDocumentContent.cdaContent);
      const je = await createReimbursementFromXML(xml, store, patient, this.cnamProcessStartedJournalEvent);
      onSuccessfulHrRetrieval?.(je);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "documentsMetadataToRetrieve", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "documentsRetrievedJournalEventsToUpdate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "rembDocumentsMetadataToRetrieve", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "hrRetrieved", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "hrProcessEnded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "nonHrProcessEnded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "nonHrRetrieved", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "nonHrUpdated", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "documentsMetadataSaved", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "documentRetrievingIndex", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "totalDocumentsToRetrieve", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "documentUpdatingIndex", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "totalDocumentsToUpdate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "nonHrDocumentsOnError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "nonHrDocumentsUpdatesOnError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _class);
export { DmpRetrievalContext as default };